

































import { Component, Vue } from 'vue-property-decorator';
import { Clock } from '@/types/clock';

@Component({
  name: 'NavBar'
})
export default class NavBar extends Vue {
  private clock: Clock = new Clock();
  private timer: any = null;

  private updateClock(): void {
    this.clock.update(new Date());
  }

  private mounted(): void {
    this.timer = setInterval(this.updateClock, 1000);
  }

  private beforeDestroy() {
    clearInterval(this.timer);
  }

  private login() {
    this.$auth.loginWithRedirect({});
  }

  private logout() {
    this.$auth.logout({
      returnTo: window.location.origin
    });
  }
}
